import { AppstoreOutlined, BarsOutlined } from '@ant-design/icons';
import { Drawer, Input, Segmented, Spin } from 'antd';
import { debounce } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { generatePath, useLoaderData, useNavigate, useSearchParams } from 'react-router-dom';
import { getVendorQuotationList } from '../../api/vendor/vendorQuotation';
import KanabanBoard from '../../components/data/kanaban/kanaban.jsx';
import QuotationFormFilter from '../../components/form/quotation/quotation-filer-form.jsx';
import { Page } from '../../components/page';
import { InfiniteTable } from '../../components/table';
import { useFetch } from '../../hooks';
import { QuoteColumn, QuoteKanabanColum } from '../../library/constants';
import { searchParamsToObject } from '../../library/helpers';
import { formatDate } from '../../library/utils';
const renderKanabanCard = ({ item, onClick }) => {
  return (<div className='kanaban__card' onClick={() => onClick(item)}>
    {item.expected_delivery_date && <div className="kanaban__card__header">
      <p className='priority'>Deadline Delivery :  {formatDate(String(item.expected_delivery_date))}</p>
    </div>}
    <div className="kanaban__card__body">
      <p className='itemName'>{item.item?.product?.name}</p>
      <p className='itemName'>Quantities : {item.item?.quantities.toString()}</p>
    </div>
    <div className="kanaban__card__footer">
      <div className="details">
        <p className='head'>Project ID</p>
        <p className='leftHead'>Recieved Date</p>
        <p className='value'>{item.global_project_id}</p>
        <p className='leftValue'>{formatDate(String(item.createdAt))}</p>
      </div>
    </div>

  </div>
  );
};


const VIEW_MODES = Object.freeze({
  LIST: "list",
  KANABAN: "kanaban",
})

const QuoteListVIew = ({ data, isLoading = false, hasMore, onChangeSort, onLoadMore, onItemClick }) => {
  return (
    <InfiniteTable
      columns={QuoteColumn}
      data={data}
      /* perPage={Number(meta?.limit)} currentPage={Number(meta?.page)} total={Number(meta?.totalCount)} */
      isLoading={isLoading}
      onChange={onChangeSort}
      onRowClick={(_, record) => onItemClick(record)}
      hasMore={hasMore}
      loadMore={onLoadMore}

    />
  )
}

QuoteListVIew.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool,
  hasMore: PropTypes.bool.isRequired,
  onChangeSort: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired
}


const QuoteKanabanView = ({ data, isLoading = false, hasMore, onLoadMore, onItemClick }) => {
  const columns = QuoteKanabanColum.map(column => ({
    ...column,
    items: data.filter(({ status }) => status === column.key) ?? []
  }))

  if (isLoading) {
    return (
      <Spin />
    )
  }

  return (
    <KanabanBoard
      columns={columns}
      onItemClick={onItemClick}
      renderItem={renderKanabanCard}
      isLoading={isLoading}
      hasMore={hasMore}
      loadMore={onLoadMore}
    />
  )
}

QuoteKanabanView.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool,
  hasMore: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired
}

function QuotationList() {
  const initialData = useLoaderData()
  const navigate = useNavigate()
  const [isFiltersVisible, setIsFiltersVisible] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const viewMode = searchParams.get('view') ?? VIEW_MODES.KANABAN
  const [list, hasMore, isLoading, searchParamsParsed, {
    setSort,
    setFilters,
    loadMore
  }] = useFetch({ initialData, autoLoad: viewMode === VIEW_MODES.KANABAN })

  const handleRowClick = (record) => {
    record.combi === 1 ?
      navigate(generatePath('/quotation/:id/combi', {
        id: record.id
      })) :
      navigate(generatePath('/quotation/:id', {
        id: record.id
      }))
  }
  const setViewMode = (mode) => setSearchParams(sp => {
    sp.set('view', mode)
    return sp
  })
  const debouncedChangeHandler = debounce(q => setFilters({ search: q }), 500)

  return (
    <Page className='quotation-list' summary={initialData?.meta?.totalCount ? `${initialData?.meta?.totalCount} Records` : 'No Records'} title="Quotations"
      backLink={false}
      header={
        <>
          <Segmented
            value={viewMode}
            options={[
              {
                value: VIEW_MODES.LIST,
                icon: <BarsOutlined />,
              },
              {
                value: VIEW_MODES.KANABAN,
                icon: <AppstoreOutlined />,
              },
            ]} onChange={setViewMode}
          />
          <Input.Search style={{ width: '50%' }} placeholder="Search" onChange={(e) => debouncedChangeHandler(e.target.value)} defaultValue={searchParamsParsed?.filter?.search ?? ''} allowClear />

          <div></div>


        </>
      }
    >
      {viewMode === VIEW_MODES.LIST
        ? <QuoteListVIew data={list} isLoading={isLoading} hasMore={hasMore} onChangeSort={setSort} onLoadMore={loadMore} onItemClick={handleRowClick} />
        : <QuoteKanabanView data={list} isLoading={isLoading} hasMore={hasMore} onLoadMore={loadMore} onItemClick={handleRowClick} />
      }
      <Drawer open={isFiltersVisible} onClose={() => setIsFiltersVisible(false)} >
        <QuotationFormFilter data={searchParamsParsed.filter} onFinish={(data) => setFilters(data)} />
      </Drawer>
    </Page>
  )
}



QuotationList.Loader = async ({ request }) => {
  const url = new URL(request.url)
  const { filter, page, sort } = searchParamsToObject(url.searchParams)
  const { data, meta } = await getVendorQuotationList({ filter, page, ...sort })
  //console.log({ Loading: data.map(r => r.id) })
  return { data, meta }

}

QuotationList.propTypes = {
  title: PropTypes.string,
}

export default QuotationList
